import React, { useState, useEffect } from 'react';
import { Users, Gift, ArrowRightLeft, Loader2 } from 'lucide-react';

export default function AdminReferrals() {
  const [data, setData] = useState({ successful_count: 0, total_bonus: '0 €', referrals: [] });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => { fetchReferrals(); }, []);

  const fetchReferrals = async () => {
    try {
      const token = localStorage.getItem('admin_token');
      const response = await fetch('/api/admin/referrals', { headers: { 'Authorization': `Bearer ${token}` } });
      if (response.ok) setData(await response.json());
    } catch (err) { console.error(err); } finally { setIsLoading(false); }
  };

  if (isLoading) return <div className="flex justify-center items-center h-64"><Loader2 className="w-8 h-8 animate-spin text-accent" /></div>;

  return (
    <div className="animate-in fade-in slide-in-from-bottom-4">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-primary">Empfehlungen (Referrals)</h1>
        <p className="text-muted-foreground">Übersicht der angeworbenen Tester und Auszahlung von Boni.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div className="bg-white p-6 rounded-xl border border-border shadow-sm flex items-center gap-4">
          <div className="p-4 rounded-lg bg-accent/10"><Users className="w-6 h-6 text-accent" /></div>
          <div>
            <p className="text-sm font-medium text-muted-foreground">Erfolgreiche Werbungen</p>
            <h3 className="text-2xl font-bold text-primary">{data.successful_count}</h3>
          </div>
        </div>
        <div className="bg-white p-6 rounded-xl border border-border shadow-sm flex items-center gap-4">
          <div className="p-4 rounded-lg bg-green-50"><Gift className="w-6 h-6 text-green-600" /></div>
          <div>
            <p className="text-sm font-medium text-muted-foreground">Ausgezahlte Boni</p>
            <h3 className="text-2xl font-bold text-primary">{data.total_bonus}</h3>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl border border-border shadow-sm overflow-hidden">
        <div className="px-6 py-4 border-b border-border bg-slate-50/50">
          <h2 className="font-semibold text-primary">Aktuelle Empfehlungen</h2>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse min-w-[600px]">
            <thead>
              <tr className="border-b border-border text-sm text-secondary bg-slate-50/50">
                <th className="p-4 font-semibold">Werber (Bestandstester)</th>
                <th className="p-4 font-semibold"></th>
                <th className="p-4 font-semibold">Geworbener (Neu)</th>
                <th className="p-4 font-semibold">Datum</th>
                <th className="p-4 font-semibold">Status Bonus</th>
              </tr>
            </thead>
            <tbody>
              {data.referrals.length === 0 ? (
                <tr><td colSpan="5" className="p-8 text-center text-muted-foreground">Keine Empfehlungen vorhanden.</td></tr>
              ) : (
                data.referrals.map((ref) => (
                  <tr key={ref.id} className="border-b border-border hover:bg-slate-50/50 transition-colors">
                    <td className="p-4 font-medium text-primary">{ref.referrer}</td>
                    <td className="p-4 text-slate-300"><ArrowRightLeft className="w-4 h-4 mx-auto" /></td>
                    <td className="p-4 text-secondary">{ref.referred}</td>
                    <td className="p-4 text-sm text-secondary">{ref.date}</td>
                    <td className="p-4">
                      {ref.status === 'completed' ? (
                        <span className="text-xs font-medium text-green-700 bg-green-100 px-2.5 py-1 rounded-full">Ausgezahlt</span>
                      ) : (
                        <span className="text-xs font-medium text-yellow-700 bg-yellow-100 px-2.5 py-1 rounded-full">Prüfung läuft</span>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}